import { TEntityUntagged } from '@obvious.tech/constellation/Entity'
import { TEntityOverride } from 'src/types'

const override: TEntityOverride<TEntityUntagged<'AnalyticsConnector'>> = {
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      id: {
        displayedName: 'ID',
      },
      name: {
        displayedName: 'Name',
      },
      ip: {
        displayedName: 'IP Address',
      },
      port: {
        displayedName: 'Port',
      },
    },
  },
}

export default override
